const ERROR_STATE = {
  empty: [
    `No data available yet. Please check back later.`,
    `It looks like there's nothing here yet.`,
    `We couldn't find any data. Try adjusting your filters or search criteria.`,
    `Oops! It seems we're out of data here.`,
    `Your data will appear here once it's available.`
  ],
  error: [
    `Oops! Something went wrong. Please try again later.`,
    `We're sorry, but we encountered an error processing your request.`,
    `An unexpected error has occurred. Our team has been notified and is working on a fix.`,
    `We're experiencing technical difficulties. Please refresh the page or try again later.`,
    `Error: Unable to complete your request at this time.`
  ],
  resolution: [
    `We're sorry you're experiencing this issue. If it persists, please email us at bcld.support@binus.edu. We're here to help!`,
    `Apologies for the inconvenience. If the problem continues, don't hesitate to reach out to our support team at bcld.support@binus.edu.`,
    `We regret that you're facing this issue. Should it persist, please contact our customer service at bcld.support@binus.edu.`,
    `Sorry for the trouble. If this issue keeps happening, please let us know at bcld.support@binus.edu. We're eager to assist you.`,
    `We apologize for any inconvenience. If the error remains, feel free to email us at bcld.support@binus.edu for further assistance.`
  ]
};

export { ERROR_STATE };
